<button
  type="button"
  class="jump-to-top"
  [ngClass]="{ reveal: show }"
  (click)="jumpToTop()"
  matTooltip="Jump To Top"
>
  <mat-icon>expand_less</mat-icon>
</button>
